import React, { useMemo, useState } from 'react'
import CheckboxOption from './CheckboxOption'
import PanelFooter from './PanelFooter'
import PanelHead from './PanelHead'
import useStagedSelection from '../useStagedSelection'

// Reads facet counts from `model.results.results.groups.org_names`,
// applied state from `model.filters.orgs.selected.orgs`,
// locked state from `model.filters.orgs.orgs_locked`.
//
// Has a local search input because the charity list can be hundreds of
// entries — the input is purely a client-side filter over the rendered list.

export default function CharityPanel({ model, changeState, search, onClose }) {
  const applied = (model.filters.orgs && model.filters.orgs.selected && model.filters.orgs.selected.orgs) || {}
  const locked = (model.filters.orgs && model.filters.orgs.orgs_locked) || {}
  const groups = (model.results && model.results.results && model.results.results.groups) || {}
  const facets = groups.org_names || {}

  const [query, setQuery] = useState('')

  const { staged, toggle, reset, apply } = useStagedSelection({
    applied,
    locked,
    model,
    changeState,
    search,
    onClose,
    commit: (updated, stagedMap) => {
      if (!updated.filters.orgs.selected) updated.filters.orgs.selected = {}
      updated.filters.orgs.selected.orgs = { ...stagedMap }
      updated.filters.orgs.on = false
    },
  })

  const options = useMemo(() => {
    const q = query.trim().toLowerCase()
    const seen = new Set()
    const list = []
    Object.keys(facets).forEach((name) => {
      seen.add(name)
      if (!q || name.toLowerCase().includes(q)) {
        list.push({ name, count: facets[name] })
      }
    })
    Object.keys(locked).forEach((name) => {
      if (!seen.has(name) && (!q || name.toLowerCase().includes(q))) {
        list.push({ name, count: null })
      }
    })
    return list
  }, [facets, locked, query])

  return (
    <>
      <PanelHead title="Filter by Charity" placeholder="Search charities" query={query} onQuery={setQuery} />
      <div className="fb-menu-list">
        {options.length === 0 && (
          <p className="fb-menu-empty">{query ? 'No charities match' : 'No charities available'}</p>
        )}
        {options.map((opt) => (
          <CheckboxOption
            key={opt.name}
            label={opt.name}
            count={opt.count}
            checked={!!staged[opt.name]}
            locked={!!locked[opt.name]}
            onToggle={() => toggle(opt.name)}
          />
        ))}
      </div>
      <PanelFooter onReset={reset} onApply={apply} />
    </>
  )
}
